// Cada envio do garçom é uma comanda na cozinha (pedido do dono, 24/09/2026).
//
// A mesa lançada pelo PDV é UM pedido — o caixa, a nota da conta e os
// relatórios contam com isso. Cada envio carimba a hora dele nos itens
// (`envio`), e aqui o pedido vira um cartão por envio: o produto lançado 20
// minutos depois não cai dentro da comanda que ainda está na chapa.
//
// O cartão do envio continua com o `id` do pedido, que é com o que se grava
// pronto/entregue no servidor; quem separa um cartão do outro na tela é a
// `_chave`. Item sem carimbo é do primeiro envio (o que criou o pedido) ou de
// antes desta versão.

/** Identidade da comanda NA TELA: o envio, ou o pedido quando ele é um só. */
export function chaveDaComanda(pedido) {
  return pedido?._chave || pedido?.id;
}

/** "2º envio" — só quando a mesa mandou mais de uma vez. */
export function rotuloEnvio(pedido) {
  return pedido?._envios > 1 ? `${pedido._envio}º envio` : "";
}

const instante = (iso) => {
  const t = new Date(iso).getTime();
  return Number.isNaN(t) ? 0 : t;
};

/** Status do cartão do envio. Pedido "pronto" = tudo saiu (o servidor devolve
 *  a comanda pra produção quando chega envio novo). Em produção, o envio que
 *  já saiu inteiro vai pra Prontos sozinho, sem esperar os outros. */
function statusDoEnvio(pedido, itens) {
  if (pedido.status !== "producao") return pedido.status;
  const vivos = itens.filter((i) => !i.deleted);
  return vivos.length && vivos.every((i) => i.pronto_at) ? "pronto" : "producao";
}

function dividir(pedido) {
  const grupos = new Map();
  for (const item of pedido.items || []) {
    const k = item.envio || "";
    if (!grupos.has(k)) grupos.set(k, []);
    grupos.get(k).push(item);
  }
  if (grupos.size < 2) return [pedido];
  const ordem = [...grupos.keys()].sort((a, b) => instante(a || pedido.created_at) - instante(b || pedido.created_at));
  return ordem.map((k, n) => {
    const itens = grupos.get(k);
    const desde = k || pedido.created_at;
    return {
      ...pedido,
      items: itens,
      created_at: desde,
      ts_producao: desde,
      status: statusDoEnvio(pedido, itens),
      _envio: n + 1,
      _envios: ordem.length,
      _chave: `${pedido.id}~${n + 1}`,
    };
  });
}

/** A fila com um cartão por envio, na ordem em que chegou na cozinha. */
export function separarEnvios(pedidos) {
  const lista = (pedidos || []).flatMap(dividir);
  return lista
    .map((p, i) => ({ p, i, t: instante(p.created_at) }))
    .sort((a, b) => a.t - b.t || a.i - b.i)
    .map(({ p }) => p);
}
